import { ActionIcon, Tooltip } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';
import { useIsFetching, useQueryClient } from '@tanstack/react-query';
import { useHotkeys } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { markRefresh } from '../services/api';

/**
 * Header'dagi "Yangilash" tugmasi — HAR BIR sahifada bor, chunki header umumiy.
 *
 * Ochiq sahifadagi BARCHA so'rovlarni serverdan qayta oladi (React Query
 * `refetchQueries({ type: 'active' })`). Har sahifaga alohida tugma qo'yilsa,
 * yangi sahifa qo'shilganda uni unutish oson edi. Boshqa (yopiq) sahifalar
 * keshini esa eskirgan deb belgilaymiz — ularga o'tilganda ham yangi ma'lumot keladi.
 *
 * Brauzerni to'liq qayta yuklashdan (F5) farqi: kirish, filtrlar, sahifa raqami va
 * yozilayotgan forma joyida qoladi.
 */
export function HeaderRefresh() {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const yuklanmoqda = useIsFetching() > 0;

  const yangila = () => {
    markRefresh();
    void qc.invalidateQueries({ refetchType: 'active' });
  };
  // Alt+R — tez yangilash (Ctrl+R brauzerning o'zini qayta yuklaydi, uni egallamaymiz)
  useHotkeys([['alt+R', yangila]]);

  return (
    <Tooltip label={`${t('header.refresh')} (Alt+R)`}>
      <ActionIcon variant="default" size="lg" onClick={yangila} aria-label={t('header.refresh')}>
        <IconRefresh
          size={18}
          style={yuklanmoqda ? { animation: 'header-refresh-spin 0.8s linear infinite' } : undefined}
        />
      </ActionIcon>
    </Tooltip>
  );
}
